import { useController } from '@framework/form/hooks/useController.ts';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import styled from 'styled-components';
import {
  ComputeExpressionMinimalBaseInput,
  type IComputeExpressionMinimalBaseInputProps,
} from './ComputeExpressionMinimalBaseInput.tsx';

const ComputeExpressionMinimalInputFormItem = styled(FormItem)`
  &&& {
    margin-bottom: 0;
    .ant-form-item-control-input-content {
      display: flex;
      flex-direction: column;
    }
  }
`;

export interface IComputeExpressionMinimalInputProps
  extends Omit<
    IComputeExpressionMinimalBaseInputProps,
    'value' | 'onChange' | 'onBlur'
  > {
  name: string;
}

/**
 * Input per la gestione dell'espressione di calcolo
 * tramite l'editor Tiptap
 */
export function ComputeExpressionMinimalInput(
  props: IComputeExpressionMinimalInputProps,
) {
  const { name, ...otherProps } = props;
  const {
    field: { value, onChange, onBlur },
  } = useController(props.name);

  return (
    <ComputeExpressionMinimalInputFormItem
      name={name}
      // Forziamo il campo ad essere considerato "touched"
      // in modo da mostrare gli errori di validazione nel momento
      // in cui si prova a sottomettere il form (tasto Applica)
      // anche senza aver interagito con il campo.
      // (altrimenti anche se ci sono errori il campo è touched = false e non si vedono)
      isAlwaysTouched
    >
      <ComputeExpressionMinimalBaseInput
        {...otherProps}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
    </ComputeExpressionMinimalInputFormItem>
  );
}
